import * as React from 'react'
import * as ReactDOM from 'react-dom'
class DonateColumnsQuote extends React.Component {
    constructor(props) {
        super(props)
        // let { sub_title_col, quote_content_columns } = props.data;
        let data = props.data;
        // let { index } = props;
        // this.state = {
        //     sub_title_col: sub_title_col,
        //     quote_content_columns: quote_content_columns,
        //     index: index,
        // }
        this.state={
            data:data,
            // DO_Name:DO_Name,
            // index: index,
        }
    }

    render() {
        // let { sub_title_col, quote_content_columns, index } = this.state;
        let data = this.state.data;
        let openQuote = document.querySelector('.col-donate-recent').classList.contains('full-row');
        let classContainerList = !openQuote ? `col-donate-recent--list row mx-0 ecf-content ecf-content-small` : `col-donate-recent--list row ecf-content ecf-content-small`
        const RENDER_HTML_OTHER_DONATED_ITEM =  data.data.map((item, index) => {
            let {_id} = index;
            let spacing_line= ``;
            if(!openQuote){
                index < data.length-1 ? spacing_line=`col-6 fw-normal mb-3 pl-md-3 pl-0` : spacing_line=`col-6 fw-normal mb-0 pl-md-3 pl-0`;
            }else{
                spacing_line=`col-4 col-md-2-5 fw-normal mb-3 px-0 px-lg-3`
            }
            return (
                <p className={`${spacing_line}`} key={`dc-${index}`}>
                    { index < 15 && (
                            <span>{item}</span>
                        )    
                    }
                </p>
            )
        })
        return (
            <div className={classContainerList}>
                {RENDER_HTML_OTHER_DONATED_ITEM}
            </div>
        );
    }
}
class DonateColumnsFullCol extends React.Component {
    constructor(props) {
        super(props)
        let { sub_title_col, quote_content_columns } = props.data;
        this.state = {
            sub_title_col: sub_title_col,
            quote_content_columns: quote_content_columns,
        }
    }

    render() {
        let { sub_title_col, quote_content_columns } = this.state;
        return (
            <div className={`col-donate__item col-2 pr-0`}>
                <div className="sub-title-col mb-4">
                    <p className="ecf-title-mini-box">{sub_title_col}</p>
                </div>
                <div className="col-donate-content" dangerouslySetInnerHTML={{
                    __html: quote_content_columns,
                }}>

                </div>
            </div>
        )
    }
};
export { DonateColumnsQuote, DonateColumnsFullCol };

